export default __webpack_public_path__ + "static/media/lisia-bachar.2bca78e9.png";